module.exports = __webpack_public_path__ + "static/media/sample_mll_destination_yard.8678681f.csv";